import { Component, OnInit } from "@angular/core";
import { ModelRestService } from "../../model-rest.service";
import { SessionService } from "../../session.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { Segment } from "../../model/segment";
import { Response } from "../../model/response";
import { RouteBooking } from "../../model/routebooking";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";

/**Componente del paso donde encontaremos el captcha para saber que no se es un bot */
@Component({
  selector: "app-commit",
  templateUrl: "./commitwppref.component.html", //AQUI! CREAR UN NUEVO COMPONENTE QUE USE EL MISMO TEMPLATE
  styleUrls: ["./commitwppref.component.css"],
})
export class CommitwpprefComponent implements OnInit {
  constructor(
    private activated_route: ActivatedRoute,
    private translate: TranslateService,
    private location: Location,
    private model: ModelRestService,
    public session: SessionService,
    private router: Router,
    private http: HttpClient
  ) {}

  public is_getting_quote: boolean = false;
  public is_captcha_solved: boolean = false;
  public segments: Segment[] = [];
  public displayModal = false;
  public notifTitle = "";
  public notifBody = "";
  public notifBody1 = "";
  public isLoading = true;
  public route;
  public buttonFlag = null;
  public commit;
  public routeX = "/confirmarwppref";
  public token = "";
  public count: number = 0;
  public labelClass: string;
  private departure: string;
  private arrival: string;
  private dateDif: string;
  public Total: number = 0;
  public ClaveVenta: string;
  public isVisible: boolean;
  public discount: number = 0;
  public Bruto: number = 0;
  public PagoParcial: number = 0;
  public TotalFinal: number = 0;
  public TotalRef: number = 0;
  public monto_ref: string;
  /**Valida que exista un datos en session, si no existe te regresa al paso de reservaciones */
  ngOnInit() {
    console.clear();
    this.is_captcha_solved = false;
    this.is_getting_quote = true;
    this.count = 0;
    this.labelClass = "6";
    this.isLoading = true;
    this.displayModal = false;
    this.isVisible = false;

    this.monto_ref = "";
    this.ClaveVenta = "";

    try {
      this.ClaveVenta =
        this.activated_route.snapshot.paramMap.get("clave_venta");
      this.monto_ref = this.activated_route.snapshot.paramMap.get("monto_ref");
    } catch (ex) {
      alert(ex);
      window.location.href = "https://chepe.mx";
    }

    if (this.ClaveVenta == "" || this.monto_ref == "") {
      window.location.href = "https://chepe.mx";
      return;
    }

    this.model
      .paymentinforef(this.ClaveVenta, this.monto_ref)
      .subscribe((response: Response<RouteBooking>) => {
        this.isLoading = false;
        if (response.status.message == "OK") {
          this.session.rb = response.data;
          this.segments=response.data.escala;
          this.session.rb.pp = false;
          this.is_getting_quote = false;
          this.displayModal = false;
          this.Total = Number(response.data.etickets_phone);
          this.discount = Number(response.data.observaciones);
          this.Bruto = Number(response.data.etickets_emergency_contact);
          this.isVisible = true;
          this.PagoParcial = Number(response.data.etickets_contact_firstName);
          this.TotalFinal = this.Total - this.PagoParcial;
          this.TotalRef = Number(response.data.etickets_contact_lastName);
        } else {
          this.GoToChepe();
          return;
        }
      });
    console.clear();
  }
  /**Función para ocultar el model */
  ocultarModel() {
    this.displayModal = false;
  }

  public getDateTable(fechaStr: string): String {
    return this.getDate(true, fechaStr);
  }

  private getWeekday(
    n: number = -1,
    full: boolean = true,
    date: string
  ): string {
    if (n == -1) {
      //let d:Date = new Date(this.date);
      let d: Date = this.mkDate(date);
      return this.getWeekday(d.getDay(), full, date);
    }
    if (!full) {
      switch (n) {
        case 0:
          return "Dom";
        case 1:
          return "Lun";
        case 2:
          return "Mar";
        case 3:
          return "Mié";
        case 4:
          return "Jue";
        case 5:
          return "Vie";
        case 6:
          return "Sáb";
      }
    } else {
      switch (n) {
        case 0:
          return "Domingo";
        case 1:
          return "Lunes";
        case 2:
          return "Martes";
        case 3:
          return "Miércoles";
        case 4:
          return "Jueves";
        case 5:
          return "Viernes";
        case 6:
          return "Sábado";
      }
    }
  }
  private getDate(with_weekday: boolean = true, date: string): string {
    //let d:Date = new Date(this.date);
    let d: Date = this.mkDate(date);
    var s: string = "";
    if (with_weekday) {
      s += this.getWeekday(d.getDay(), false, date) + " ";
    }
    s += d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
    return s;
  }
  private mkDate(s: string): Date {
    var mps: string[] = s.split(" ");
    let now: Date = new Date();
    if (mps.length == 1) {
      mps.push("00:00:01");
    }
    let dps: string[] = mps[0].split("-");
    let tps: string[] = mps[1].split(":");

    let year: number = dps.length >= 1 ? parseInt(dps[0]) : now.getFullYear();
    let month: number = dps.length >= 2 ? parseInt(dps[1]) - 1 : now.getMonth();
    let day: number = dps.length >= 3 ? parseInt(dps[2]) : now.getDate();

    let hour: number = tps.length >= 1 ? parseInt(tps[0]) : now.getHours();
    let minute: number = tps.length >= 2 ? parseInt(tps[1]) : now.getMinutes();
    let second: number = tps.length >= 3 ? parseInt(tps[2]) : now.getSeconds();

    let dd: Date = new Date(year, month, day, hour, minute, second);
    return dd;
  }

  public getDuration(date: string, departure: string, arrival: string): string {
    this.departure = departure;
    this.arrival = arrival;
    this.dateDif = date;

    var dd = this.mkDate(this.getDepartureDateTime());
    var ad = this.mkDate(this.getArrivalDateTime());

    if (this.getArrivalDateTime() < this.getDepartureDateTime()) {
      dd = this.mkDate(this.getArrivalDateTime());
      ad = this.mkDate(this.getDepartureDateTime());
    }

    if (ad.getHours() != 0 && dd.getHours() != 0) {
      var dif: number = ad.getTime() - dd.getTime();

      var s: number = 1000;
      var m: number = s * 60;
      var h: number = m * 60;
      var hrs: number = Math.ceil(dif / h) - 1;
      dif = dif % h;
      var mins: number = Math.ceil(dif / m);

      var hrss: string = hrs < 10 ? "0" + hrs : "" + hrs;
      var minss: string = mins < 10 ? "0" + mins : "" + mins;

      return hrss + ":" + minss;
    }

    if (ad.getHours() == 0 || dd.getHours() == 0) {
      var dif: number = ad.getTime() - dd.getTime();

      var s: number = 1000;
      var m: number = s * 60;
      var h: number = m * 60;
      var hrs: number = Math.ceil(dif / h);
      dif = dif % h;
      var mins: number = Math.ceil(dif / m);
      hrs = 24 - hrs;
      mins = 60 - mins;
      var hrss: string = hrs < 10 ? "0" + hrs : "" + hrs;
      var minss: string = mins < 10 ? "0" + mins : "" + mins;

      return hrss + ":" + minss;
    }
  }

  private getDepartureTime(): string {
    return this.departure;
  }
  private getArrivalTime(): string {
    return this.arrival;
  }
  private getDepartureDateTime(): string {
    return this.dateDif + " " + this.departure;
  }
  private getArrivalDateTime(): string {
    return this.dateDif + " " + this.arrival;
  }

  /**Función que te manda un aviso si quieres continuar al pago si es asi te redirige al paso de pago */
  public bookIt() {
    let r = JSON.stringify(this.session.rb);
    sessionStorage.setItem("route", r);
    this.isLoading = false;
    this.displayModal = true;
    this.notifTitle = "";
    this.notifBody = "¿Desea proceder al pago?";
    this.route = "/pagowpp";
  }

  public GoToChepe() {
    this.isLoading = false;
    this.displayModal = true;
    this.notifTitle = "";
    this.notifBody = "Clave de venta incorrecta";
    this.route = "/";
  }

  public getTotalPassengers() {
    return this.session.rb.persons.length;
  }
  /**Función del captcha */
  captchaSolved(captchaResponse: string) {
    this.buttonFlag = null;
    this.is_captcha_solved = false;
    this.commit = this.translate.instant("Com1-P09");
    this.token = captchaResponse;

    //this.is_captcha_solved=true;//quitar en prod

    this.model.getIsValidRecaptcha(captchaResponse).subscribe((data) => {
      if (data.success) {
        if (data.data.success.toUpperCase() == "TRUE") {
          this.is_captcha_solved = true;
        }
      } else {
        this.is_captcha_solved = false;
      }

      if (!this.is_captcha_solved) {
        alert("No se pudo validar el recaptcha");
      }
    });
  }

  public isReadytoPay() {
    if (this.session.rb.pp && this.is_captcha_solved) {
      return true;
    } else {
      return false;
    }
  }
}
